<template>
    <div class="order">
        <div class="order-title-list">
            <div class="order-title-each" :class="{ 'select': pageShow === '0' }" @click="changePageShow('0')">全部</div>
            <div class="order-title-each" :class="{ 'select': pageShow === '1' }" @click="changePageShow('1')">未完成</div>
            <div class="order-title-each" :class="{ 'select': pageShow === '2' }" @click="changePageShow('2')">已完成</div>
        </div>
        <div class="order-content-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled"
            infinite-scroll-distance="20" infinite-scroll-immediate="false">
            <div class="order-content-each" v-for="(item, value) in rows" :key="value" @click="toTeachDetail(item)">
                <div class="order-id-all">
                    <div class="order-id">订单编号：{{ item.id }}</div>
                    <div class="order-status" v-if="item.status === '0'">未完成</div>
                    <div class="order-status" v-if="item.status === '1'">已完成</div>
                </div>
                <div class="order-info">
                    <template v-if="item.image != null && item.image != ''">
                        <img :src=item.image class="order-img" />
                    </template>
                    <template v-else>
                        <img src="../assets/image/teaching-img.png" class="order-img" />
                    </template>
                    <div class="order-text">
                        <div class="order-name">{{ item.name }}</div>
                        <div class="order-price">¥ {{ item.orderPrice }}</div>
                    </div>
                </div>
            </div>
            <!-- 下拉加载时候加loading旋转动效 -->
            <div v-if="loading" style="margin-top:10px;" class="loading">
                <span>loding...</span>
            </div>
        </div>
    </div>
</template>
<script>
import { listOrder } from '@/api/common'
export default {
    name: 'MyOrderPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            pageShow: '0', // 0: 全部 1：未完成 2：已完成
            rows: [],
            pageNum: 1,
            pageSize: 5,
            loading: false,
            pageIndex: 1,
            pages: ''
        }
    },
    created() {
        this.merchantId = this.id;
        if (this.$route.query) {
            this.pageShow = this.$route.query.pageShow;
        }
        this.getOrderList();
    },
    //计算
    computed: {
        noMore() {
            //当起始页数大于总页数时停止加载
            return this.pageIndex >= this.pages;
        },
        disabled() {
            return this.loading || this.noMore;
        }
    },
    methods: {
        getOrderList() {
            let params = {
                'pageSize': this.pageSize,
                'pageNum': this.pageNum,
                'orderByColumn': 'tgo.create_time desc,tgo.id',
                'isAsc': 'desc'
            };
            if (this.pageShow === '1') {
                params.status = '0'
            }
            if (this.pageShow === '2') {
                params.status = '1'
            }
            listOrder(params).then((res) => {
                if (res.code === 200) {
                    this.rows = this.rows.concat(res.rows);
                    this.pages = Math.ceil(res.total / this.pageSize);
                }
            })
        },
        load() {
            //滑到底部时进行加载
            this.loading = true;
            let params = {
                'pageSize': this.pageSize,
                'pageNum': this.pageIndex + 1,
                'orderByColumn': 'tgo.create_time desc,tgo.id',
                'isAsc': 'desc'
            };
            if (this.pageShow === '1') {
                params.status = '0'
            }
            if (this.pageShow === '2') {
                params.status = '1'
            }
            listOrder(params).then((res) => {
                this.rows = this.rows.concat(res.rows);
                this.pageIndex++
                this.loading = false;
            })
        },
        changePageShow(index) {
            this.pageShow = index;
            this.resetOrderList();
        },
        resetOrderList() {
            this.rows = [];
            this.pageIndex = 1;
            this.pages = '';
            this.loading = false;
            this.getOrderList();
        },
        toTeachDetail(item) {
            this.$router.push({
                path: '/teaching/' + this.merchantId, query: {
                    teachingId: item.teachingGatherId,
                }
            });
    }
    }
}
</script>
<style scoped>
.order {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    overflow: hidden;
}

.order-title-list {
    display: flex;
    padding: 12px 20px;
    background-color: #fff;
    overflow: hidden;
}

.order-title-each {
    margin-right: 60px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 500;
}

.order-title-each.select {
    color: #13D275;
}

.order-title-each:last-child {
    margin-right: 0;
}

.order-content-list {
    flex: 1;
    overflow-y: auto;
}

.order-content-each {
    padding: 15px 15px 18px 15px;
    margin-top: 5px;
    /* min-height: 150px; */
    background-color: #fff;
}

.order-id-all {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}

/* 加载时候转圈的动效 */
.loading {
    text-align: center;
}

.loading span {
    display: inline-block;
    font-size: 14px;
    color: #666;
}

.order-info {
    display: flex;
    margin-top: 10px;
}

.order-img {
    margin-right: 10px;
    width: 142px;
    height: 90px;
    object-fit: cover;
    border-radius: 5px;
}

.order-text {
    flex: 1;
}

.order-name {
    font-family: PingFangHK-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    font-weight: 400;
    text-align: left;
}

.order-price {
    margin-top: 28px;
    text-align: right;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}
</style>
